module.exports = StyledSystem;